export const typography = {
  htmlFontSize: 16,
  fontFamily: `
    "Poppins", -apple-system, BlinkMacSystemFont, "Segoe UI",
    "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans",
    "Helvetica Neue", sans-serif
  `,
  fontWeightLight: 300,
  fontWeightMedium: 500,
  fontWeightBold: 700,
  h1: {
    fontWeight: 300,
    fontSize: '3.25rem',
  },
  h2: {
    fontWeight: 500,
    fontSize: '2.75rem',
  },
  h3: {
    fontWeight: 600,
    fontSize: '2rem',
  },
  h4: {
    fontWeight: 600,
    fontSize: '1.625rem',
  },
  h5: {
    fontWeight: 500,
    fontSize: '1.45rem',
  },
  h6: {
    fontWeight: 600,
    fontSize: '1.125rem',
  },
  subtitle1: {
    fontWeight: 600,
    fontSize: '1rem',
  },
  subtitle2: {
    fontWeight: 700,
    fontSize: '0.875rem',
  },
  body1: {
    fontWeight: 500,
    fontSize: '1rem',
  },
  body2: {
    fontWeight: 500,
    fontSize: '0.875rem',
    color: '#757A96',
  },
  button: {
    fontWeight: 500,
    fontSize: '0.875rem',
  },
  caption: {
    fontWeight: 500,
    fontSize: '0.75rem',
  },
  overline: {
    fontWeight: 700,
    fontSize: '0.75rem',
  },
};
